// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "16px";
var _4 = "list-29cfZ";
var _5 = "item-2FI2n";
var _6 = "item_FNN-3KykZ";
var _7 = "withGroupsWrapper-18uAx";
var _8 = "withGroupsDelimiter-1wUy5";
var _9 = "groupsWrapper-2vI7-";
var _a = "passengersWrapper-2hHhZ";
var _b = "groupsTitle-3Cf7r";
var _c = "passengersTitle-1nIl-";
var _d = "fareGroups-7zDg8";
var _e = "fareGroup-23T4D";
var _f = "currentGroup-27zpb";
var _10 = "slider-3FG6Y";
export { _1 as "__esModule", _2 as "mobile", _3 as "block_padding", _4 as "list", _5 as "item", _6 as "item_FNN", _7 as "withGroupsWrapper", _8 as "withGroupsDelimiter", _9 as "groupsWrapper", _a as "passengersWrapper", _b as "groupsTitle", _c as "passengersTitle", _d as "fareGroups", _e as "fareGroup", _f as "currentGroup", _10 as "slider" }
export default { "__esModule": _1, "mobile": _2, "block_padding": _3, "list": _4, "item": _5, "item_FNN": _6, "withGroupsWrapper": _7, "withGroupsDelimiter": _8, "groupsWrapper": _9, "passengersWrapper": _a, "groupsTitle": _b, "passengersTitle": _c, "fareGroups": _d, "fareGroup": _e, "currentGroup": _f, "slider": _10 }
